import axios from "axios";
// import {saveAs} from 'file-saver';
const { saveAs } = require("file-saver");

export const ORCAMENTOS_EXTENSION = "/orcamentos";
export const OCORRENCIAS_EXTENSION = "/ocorrencias";
export const DESPESAS_EXTENSION = "/despesas";
export const FATURACAO_CLIENTES_EXTENSION = "/faturacao-clientes";
export const FATURACAO_FORNECEDORES_EXTENSION = "/faturacao-fornecedores";
export const OBRAS_EXTENSION = "/obras";
export const CLIENTS_EXTENSION = "/clients";
export const FORNECEDORES_EXTENSION = "/fornecedores";
export const MACHINES_EXTENSION = "/machines";
export const NOTAS_CREDITO_FORNECEDORES_EXTENSION = "/notas-credito-fornecedores";
export const NOTAS_CREDITO_CLIENTES_EXTENSION = "/notas-credito-clientes";
export const NOTIFICACOES_EXTENSION = "/notificacoes";
export const DISPOSITIVOS_MEDICAO_EXTENSION = "/dispositivo-medicao";
export const CONFIGURATIONS_EXTENSION = "/notificacoes/configurations";
export const MATERIAIS_EXTENSION = "/materiais";
export const RECIBOS_EXTENSION = "/recibos";
export const PEDIDOS_ORCAMENTO_EXTENSION = "/pedidos-orcamento";
export const UTILIZADORES_EXTENSION = "/utilizadores";
export const NOTAS_ENCOMENDA_EXTENSION = "/notas-encomenda";
export const ENTRADAS_MATERIAL_EXTENSION = "/entradas-material";
export const NAO_CONFORMIDADES_CLIENTES_EXTENSION = "/nao-conformidades-clientes";
export const NAO_CONFORMIDADES_FORNECEDORES_EXTENSION = "/nao-conformidades-fornecedores";

export const buildEndpoint = (ENDPOINT_EXTENSION: string) => {
	return `${process.env.REACT_APP_API_ENDPOINT}${ENDPOINT_EXTENSION}`;
};

export const genericGet = async (extension: string) => {
	const response = await axios.get(buildEndpoint(extension));
	return response.data;
};

export const genericGetWithProcessor = async (extension: string, processor: Function) => {
	const response = await axios.get(buildEndpoint(extension));
	const processedEntity = response.data.map((o: any) => {
		return processor(o);
	});

	return processedEntity;
};

export const paginatedGetWithProcessor = (extension: any, processor: any) => {
	async function get({ page, take, filters }: { page: any; take: any; filters: any }) {
		let endpoint = buildEndpoint(`${extension}`);

		let finalEndpoint = endpoint + `?page=${page + 1}`;

		if (take) {
			finalEndpoint = finalEndpoint + `&take=${take}`;
		}

		const response = (await axios.get(finalEndpoint)).data;
		const processedEntity = response.data.map((o: any) => {
			return processor(o);
		});

		return { data: processedEntity, meta: response.meta };
	}
	return get;
};

export const genericPost = (extension: string) => {
	async function post(data: any) {
		const response = await axios.post(buildEndpoint(extension), data);
		return response;
	}
	return post;
};

export const genericFileUpload = (extension: string) => {
	async function post(data: any) {
		const response = await axios.post(buildEndpoint(extension), data, {
			headers: {
				"Content-Type": "multipart/form-data",
			},
		});
		return response;
	}
	return post;
};

export const uploadFile = async ({ extension, data }: { extension: string; data: FormData }) => {
	const post = genericFileUpload(extension);
	return await post(data);
};

export const genericPatch = <T>(extension: string): ((data: T) => Promise<any>) => {
	async function patch(data: T) {
		console.log("Calling patch with data: ", data);
		const response = await axios.patch(buildEndpoint(extension), data);
		return response;
	}
	return patch;
};

export const patchWithDataAndId = (extension: string): ((params: { data: any; id: string }) => Promise<any>) => {
	async function patch({ data, id }: { data: any; id: string | number }) {
		const response = await axios.patch(buildEndpoint(id ? `${extension}/${id}` : extension), data);
		return response;
	}
	return patch;
};

export const genericDelete = (extension: string) => {
	async function del(id?: string | number) {
		const response = await axios.delete(buildEndpoint(id ? `${extension}/${id}` : extension));
		return response;
	}
	return del;
};

export const genericUpdate = (extension: string) => {
	async function update(id: any, data: any) {
		const response = await axios.patch(buildEndpoint(`${extension}/${id}`), data);
		return response;
	}
	return update;
};

export const authenticate = async (data: any) => {
	const response = await axios.post(buildEndpoint("/auth/login"), {}, { auth: { username: data.email, password: data.password } });
	return response.data;
};

export const genericGetWithFilters = async (location: any, query: any, dataBuildFunction: Function) => {
	const endpoint = buildEndpoint(location) + "?";
	let queryString = "";
	query.page += 1;
	Object.entries(query)
		.filter(([k, v]: [k: string, v: any]) => v != undefined && v != null)
		.map(([k, v]: [k: string, v: any], idx) => {
			if (k === "sort") {
				queryString += `${k}=${JSON.stringify(v)}`;
			} else {
				const queryParam = v?.id ? v.id : v;
				queryString += `${k}=${queryParam}`;
			}

			if (idx != Object.entries(query).length - 1) {
				queryString += "&";
			}
		});
	const endpointQuery = endpoint + queryString;
	const response = (await axios.get(endpointQuery)).data;
	const data = response.data.map((d: any) => dataBuildFunction(d));

	return { data: data, meta: response.meta };
};

export const generalObjectBuilder = (objectConfigs: any) => {
	return (response: any) => {
		const obj: any = {};
		objectConfigs.map((oc: any) => {
			obj[oc.id] = { value: response[oc.id] };
		});

		return obj;
	};
};

export const genericGeneratePdf = (entity: string) => {
	return async (id: any) => {
		const response = await axios.post(buildEndpoint(`/pdfgenerator${entity}/${id}`), {}, { responseType: "blob" });
		const buffer = await response.data;
		const blob = new Blob([buffer], { type: "application/pdf;" });
		saveAs(blob, `Nota-encomenda-${id}.pdf`);
		return buffer;
	};
};

export const generateFolhaObra = async (obraId: string, entregaId: string, posto: string) => {
	const response = await axios.post(buildEndpoint(`/pdfgenerator/folha-obra/${obraId}/entregas/${entregaId}/posto/${posto}`), {}, { responseType: "blob" });
	const buffer = await response.data;
	const blob = new Blob([buffer], { type: "application/pdf;" });
	saveAs(blob, `Folha-obra-${obraId}-${entregaId}.pdf`);
	return buffer;
};

export const generateOrcamentoPdf = async (orcamentoId: string) => {
	const response = await axios.post(buildEndpoint(`/pdfgenerator/orcamento/${orcamentoId}`), {}, { responseType: "blob" });
	const buffer = await response.data;
	const blob = new Blob([buffer], { type: "application/pdf;" });
	saveAs(blob, `Orçamento-${orcamentoId}.pdf`);
	return buffer;
};

export const fetchDesenhosRelatorioControlo = async (relatorioId: number | null) => {
	if (!relatorioId) return null;
	const response = await axios.get(buildEndpoint(`/relatorios-controlo/${relatorioId}/anexos/download`));
	return response;
};

export const getUserByPin = async (pin: string) => {
	return (await axios.get(buildEndpoint(`/utilizadores/by-pin/${pin}`))).data;
};

export const picarEvento = async (evento: string, body: { userId: number; data: Date }) => {
	console.log("received evento: ", evento);
	console.log("Body: ", body);
	return (await axios.post(buildEndpoint(`/utilizadores/picar/${evento}`), body)).data;
};

export const getHistoricoPicagens = async (data: string): Promise<{ [userName: string]: { Entrada: string[]; Saida: string[] } }> => {
	return (await axios.get(buildEndpoint(`/utilizadores/picagens/historico-diario/${data}`))).data;
};

export const notifyClient = async (id: number, email: string) => {
	return (await axios.put(buildEndpoint(`/entregas/${id}/notify-client`), { email })).data;
};

export const sendQuestionnaire = async (id: number, email: string) => {
	return (await axios.put(buildEndpoint(`/obras/${id}/send-questionnaire`), { email })).data;
};
